import { Auth } from 'aws-amplify'

export const setToken = async () => {
  const session = await Auth.currentSession()
  // token.set(session.getIdToken().getJwtToken())
  return `Bearer ${session.getIdToken().getJwtToken()}`
}
